import { isHTMLContentEmpty } from "helpers/common";
import errorMessages from "utils/validation/errorMessages";
import {
    emailSchema,
    phoneRequiredSchema,
    select2RequiredSchema,
    stringOptionalSchema,
    stringRequiredSchema
} from "utils/validation/validationHelpers";
import { array, object, string } from "yup";

/* STEP 1 */
export const step1Schema = object().shape({
    firstname: stringRequiredSchema,
    lastname: stringRequiredSchema,
    phone: phoneRequiredSchema,
    email: emailSchema,
    // city: stringRequiredSchema,
    // address1: stringRequiredSchema,
    // postal_code: stringRequiredSchema,
});

/* STEP 2 */
export const step2Schema = (totalPolicies = 0) =>
    object().shape({
        policies: array()
            .required(errorMessages.required)
            .test(
                "all-policies-accepted",
                "Please accept all policies to continue",
                (policies = []) => {
                    if (!totalPolicies) return false;

                    // All policies must be accepted
                    return (
                        policies.length === totalPolicies &&
                        policies.every((p) => p.is_accepted === true)
                    );
                }
            ),
    });

/* STEP 3 */
export const step3Schema = object().shape({
    documents: object()
        .nullable()
        .notRequired()
        .shape({
            policy_check: string().nullable().url(errorMessages.url),

            business_license: string().nullable().url(errorMessages.url),
            college_registration: string().nullable().url(errorMessages.url),
            professional_liabilities_insurance: string()
                .nullable()
                .url(errorMessages.url),

            professional_liabilities_insurances: array().of(
                object().shape({
                    label: string().nullable(),
                    file: string().nullable().url(errorMessages.url),
                })
            ),
        }),
});
/* STEP 4 */
export const step4Schema = object().shape({
    signature_img: stringRequiredSchema.url(errorMessages.url),
    email_signature: string().test(
        "email-signature-required",
        "Email signature is required",
        (value) => {
            if (!value || isHTMLContentEmpty(value)) {
                return false;
            }
            return true;
        }
    ),

});


/* RESOLVER */
const onboardSchema = (step, totalPolicies = 0) => {
    switch (step) {
        case 1:
            return step1Schema;
        case 2:
            return step2Schema(totalPolicies);
        case 3:
            return step3Schema;
        case 4:
            return step4Schema;
        default:
            return null;
    }
};

export default onboardSchema;